import { useState, useEffect } from 'react'
import Card, { CardHeader } from '../ui/Card'
import Badge from '../ui/Badge'
import SectionLabel from '../ui/SectionLabel'
import LoadingBear from '../ui/LoadingBear'
import { fetchJournals } from '../../api/client'

export default function JournalPanel() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchJournals().then(setData).finally(() => setLoading(false))
  }, [])

  if (loading) return <LoadingBear message="Reading the journals..." />

  return (
    <div>
      <SectionLabel>Panel 5 — Journal Timeline</SectionLabel>

      <Card delay={0.05}>
        <CardHeader title="Journal Timeline" badge={`${data?.count ?? 0} entries`} badgeVariant="gold" />
        <div className="space-y-4">
          {(data?.entries ?? []).map((entry, i) => (
            <JournalEntry key={entry.id || i} entry={entry} />
          ))}
          {(!data?.entries || data.entries.length === 0) && (
            <p className="text-mm-parchment/30 text-sm text-center py-8">No journals yet</p>
          )}
        </div>
      </Card>
    </div>
  )
}

function JournalEntry({ entry }) {
  const weightColor = {
    heavy: 'bg-mm-persimmon',
    medium: 'bg-mm-persimmon/50',
    light: 'bg-mm-sage',
  }

  const authorColor = entry.context?.includes('sparrow') ? 'persimmon' : 'viridian'

  return (
    <div className="py-3 border-b border-mm-border last:border-b-0">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <div className={`w-1.5 h-1.5 rounded-full ${authorColor === 'viridian' ? 'bg-mm-viridian' : 'bg-mm-persimmon'}`} />
          <span className="text-[11px] text-mm-parchment/50">{entry.date}</span>
        </div>
        <div className="flex items-center gap-2">
          {entry.weight && (
            <div className={`w-1.5 h-1.5 rounded-full ${weightColor[entry.weight] ?? 'bg-mm-sage'}`} />
          )}
          {entry.context && <Badge variant="parchment">{entry.context}</Badge>}
        </div>
      </div>
      <p className="text-xs text-mm-parchment/80 leading-relaxed line-clamp-3">
        {entry.text}
      </p>
    </div>
  )
}
